// extracted by mini-css-extract-plugin
export var topImageWrapper = "BlogPost-module--topImageWrapper--2do1t";
export var pageHeaderWrapper = "BlogPost-module--pageHeaderWrapper--1J0Nu";
export var title = "BlogPost-module--title--3Ao1s";
export var author = "BlogPost-module--author--2FHi7";
export var readtime = "BlogPost-module--readtime--3dj9a";
export var topInfoRow = "BlogPost-module--topInfoRow--3kTsw";
export var tags = "BlogPost-module--tags--27Vj6";
export var tag = "BlogPost-module--tag--350mf";